import { Link } from "react-router";
import { getProfilesAlternativePath } from "@routes/Author/utils/helpers";
import { FeedAuthor } from "@routes/Author/utils/types";
import { cn } from "@util/helpers";

export type BylineNameProps = {
  /** Author object containing image and name */
  author: FeedAuthor;
  /** Separator to use between author names */
  separator: "," | "&" | "";
  /** Optional CSS class to apply to the name element */
  className?: string;
  /** Optional URL search parameters for the link */
  linkParams?: URLSearchParams;
};

/**
 * ArticleBylineName component that displays the author's name in the byline.
 * It renders a link to the author's profile if a URL path is provided.
 */
const ArticleBylineName = ({
  author,
  separator,
  className = "",
  linkParams,
}: BylineNameProps) => {
  const authorName = author.name;
  const alternativePath = getProfilesAlternativePath(
    author.urlPath?.replace("/authors/", "")
  );

  const urlPath = alternativePath || author.urlPath;
  const params = linkParams ? `?${linkParams.toString()}` : "";

  return (
    <h4 className={cn(className)} data-testid="article-byline-name-component">
      {urlPath ? (
        <Link
          to={`${urlPath}${params}`}
          className={cn("!text-gray-850 hover:underline")}
          target="_blank"
          reloadDocument
        >
          {authorName} {separator}
        </Link>
      ) : (
        <>
          {authorName} {separator}
        </>
      )}
    </h4>
  );
};

export default ArticleBylineName;
